import Storage from './Storage'
import { Jwt } from './resources'

const sessionStorage = new Storage(window.sessionStorage)

export default {
  get token () {
    return sessionStorage.get('token')
  },
  set token (value) {
    value ? sessionStorage.set('token', value) : sessionStorage.remove('token')
  },
  accessToken (email, password) {
    return Jwt.accessToken(email, password).then((response) => {
      this.token = response.data.token
    })
  },
  getAuthorizationHeader () {
    return `Bearer ${this.token}`
  },
  refreshToken () {
    return Jwt.refreshToken().then(response => {
      this.token = response.data.token
    })
  },
  unauthenticate () {
    console.log('jwtToken unauthenticate')
    return Jwt.unauthenticate()
  }
}
